import styled from 'styled-components'
// constants
import { WYSIWIG_CLASS_NAMES } from 'constants/wysiwig'
// themes
import { colors } from 'themes/index'
// icons
import DocumentIconOrigin from '@mui/icons-material/FindInPage'
// utils
import { size } from 'polished'

export const Wrapper = styled('div')`
  display: flex;
  margin-top: 8px;

  label {
    top: 10px;
  }

  .${WYSIWIG_CLASS_NAMES.wrapperClassName} {
    margin: 32px 0 0;
  }

  .${WYSIWIG_CLASS_NAMES.editorClassName} {
    background-color: ${colors.white100};
    display: flex;
    height: 240px;
    border-radius: 3px;

    & > div {
      height: fit-content;
      width: 100%;
    }
  }

  .${WYSIWIG_CLASS_NAMES.blockTypeClassName} {
    overflow-y: auto;
    position: unset;
    width: 110px;
  }

  .${WYSIWIG_CLASS_NAMES.fontSizeClassName} {
    max-height: 90px;
    overflow-y: auto;
    position: unset;
    width: 40px;
  }

  .${WYSIWIG_CLASS_NAMES.fontFamilyClassName} {
    overflow-y: auto;
    position: unset;
    width: 115px;
  }

  .${WYSIWIG_CLASS_NAMES.toolbarClassName} {
    background-color: ${colors.gray190};
  }

  ul {
    max-height: 90px;
  }
`

export const DocumentIcon = styled(props => <DocumentIconOrigin {...props} />)`
  && {
    cursor: pointer;
    margin-top: -2px;
    position: relative;
    top: 33px;

    ${size('30px')};
  }
`
